import SearchAppService from '../_shared/api/searchAppService';
import { SearchRequest } from '../global.d';
import Singleton from '../Singleton';

export default class TradeSearchService extends Singleton<TradeSearchService> {
  static getSearchBuyList = async (requestBody: SearchRequest) => {
    let trades;
    try {
      const client = await SearchAppService();
      trades = await client.trade.tradeSearchBuy(requestBody);
    } catch (error) {
      return error?.response?.data;
    }
    return trades?.data;
  };

  static getSearchSellList = async (requestBody: SearchRequest) => {
    let trades;
    try {
      const client = await SearchAppService();
      trades = await client.trade.tradeSearchSell(requestBody);
    } catch (error) {
      return error?.response?.data;
    }
    return trades?.data;
  };
}
